<template>
  <div class="questions">
    <OverlayWindow size="large" v-on:done="closeQuestions">
      <template v-slot:title>
        <span v-if="tour.questions_infotext" v-html="tour.questions_infotext"></span>
        <template v-else>{{ $t('GUIDED_TOUR_QUESTIONS') }}</template>
      </template>
      <div class="questionsForm">
        <div class="question" v-for="question in tour.questions" v-bind:key="question.id">
          <div class="questionText">
            {{ question.question
            }}<span v-if="parseInt(question.is_mandatory, 10) === 1">
              <Icon class="required" icon="asterisk" />
            </span>
          </div>
          <template v-if="question.type === 'radio'">
            <RadioInput
              class="radio"
              v-for="answer in question.answers"
              v-bind:key="answer.id"
              :label="answer.answer"
              :fname="'radio-' + question.id + '-' + answer.id"
              :value="answerVal(question.id, answer.id)"
              type="button"
              v-on:input="setRadioAnswer"
            >
            </RadioInput>
          </template>
          <template v-else-if="question.type === 'number'">
            <NumberInput
              :fname="'number-' + question.id"
              :model-value="answerVal(question.id)"
              @update:model-value="setTextAnswer('number', question.id, $event)"
            ></NumberInput>
          </template>
          <template v-else-if="question.type === 'text'">
            <TextInput
              :fname="'text-' + question.id"
              :model-value="answerVal(question.id)"
              @update:model-value="setTextAnswer('text', question.id, $event)"
            ></TextInput>
          </template>
          <template v-else-if="question.type === 'textarea'">
            <TextAreaInput
              :fname="'text-' + question.id"
              :model-value="answerVal(question.id)"
              @update:model-value="setTextAnswer('textarea', question.id, $event)"
            ></TextAreaInput>
          </template>
          <template
            v-else-if="question.type === 'checkbox'"
            v-for="answer in question.answers"
            v-bind:key="answer.id"
          >
            <CheckInput
              class="check"
              :label="answer.answer"
              :fname="'checkbox-' + question.id + '-' + answer.id"
              :model-value="answerVal(question.id, answer.id)"
              @update:model-value="(v) => setCheckboxAnswer(question.id, answer.id, v)"
            ></CheckInput>
          </template>
          <template v-else-if="question.type === 'select'">
            {{ $t('SELECT_INPUT_PLACEHOLDER') }}
            <SelectInput
              :placeholder="$t('SELECT_INPUT_PLACEHOLDER')"
              value="-1"
              :fname="'select-' + question.id"
              :options="selectOptions(question.answers)"
              v-on:input="setSelectAnswer(question, $event)"
            ></SelectInput>
          </template>
          <div
            v-if="
              parseInt(question.is_mandatory, 10) === 1 && !firstTry && !validateField(question)
            "
            class="validationErrors"
          >
            <small>
              {{ $t('FIELD_IS_REQUIRED') }}
            </small>
          </div>
        </div>
      </div>
      <template v-slot:actions>
        <button type="button" class="closeButton" v-on:click="closeQuestions">
          {{ $t('NAV_BACK') }}
        </button>
        <button type="button" v-on:click="addToCart()">{{ $t('GUIDED_TOUR_BUY') }}</button>
      </template>
    </OverlayWindow>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import RadioInput from '../Form/RadioInput.vue';
import NumberInput from '../Form/NumberInput.vue';
import CheckInput from '../Form/CheckInput.vue';
import SelectInput from '../Form/SelectInput.vue';
import TextInput from '../Form/TextInput.vue';
import TextAreaInput from '../Form/TextAreaInput.vue';
import CloseIcon from '../CloseIcon.vue';
import Icon from '../Icon.vue';
import OverlayWindow from '../OverlayWindow/OverlayWindow.vue';

export default {
  name: 'QuestionsComponent',
  data() {
    return {
      firstTry: true,
    };
  },
  components: {
    RadioInput,
    NumberInput,
    CheckInput,
    SelectInput,
    TextInput,
    TextAreaInput,
    CloseIcon,
    Icon,
    OverlayWindow,
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      tour: (state) => state.guidedTours.data.single,
      answers: (state) => state.guidedTours.form.answers,
      questions: (state) => state.guidedTours.data.single.questions,
    }),
  },
  methods: {
    ...mapActions({
      setAnswer: 'guidedTours/setAnswer',
      clearAnswers: 'guidedTours/clearAnswers',
    }),
    answerVal(questionId, answerId) {
      const answer = this.answers[questionId];
      if (typeof answer !== 'undefined') {
        if (typeof this.answers[questionId].type !== 'undefined') {
          if (this.answers[questionId].type === 'radio') {
            if (this.answers[questionId].value === answerId) {
              return true;
            }
          } else if (this.answers[questionId].type === 'checkbox') {
            return this.answers[questionId].value.includes(answerId);
          } else if (this.answers[questionId].type === 'select') {
            let index = -1;
            this.answers[questionId].answers.find((e, i) => {
              if (e.id === answerId) {
                index = i;
                return true;
              }
              return false;
            });
            return index;
          } else if (
            this.answers[questionId].type === 'number' ||
            this.answers[questionId].type === 'text' ||
            this.answers[questionId].type === 'textarea'
          ) {
            return this.answers[questionId].value;
          }
        }
      }
      let shouldReturn = false;
      this.questions.find((q) => {
        if (q.id === questionId) {
          if (q.type === 'checkbox') {
            shouldReturn = true;
            return;
          }
        }
      });
      if (shouldReturn) return false;
      return '';
    },
    addToCart() {
      this.firstTry = false;
      const foundNotFilled = this.$store.state.guidedTours.data.single.questions.find((q) => {
        const isValid = this.validateField(q);
        return !isValid;
      });
      if (typeof foundNotFilled === 'undefined') {
        this.$emit('done');
      }
    },
    validateField(q) {
      let pass = true;
      if (parseInt(q.is_mandatory, 10) === 1) {
        pass = false;
        if (typeof this.answers[q.id] !== 'undefined') {
          if (
            (this.answers[q.id].type === 'text' && this.answers[q.id].value.trim() !== '') ||
            (this.answers[q.id].type === 'textarea' && this.answers[q.id].value.trim() !== '') ||
            (this.answers[q.id].type === 'number' && !Number.isNaN(this.answers[q.id].value)) ||
            (this.answers[q.id].type === 'select' && this.answers[q.id].value !== '') ||
            (this.answers[q.id].type === 'checkbox' && this.answers[q.id].value.length > 0) ||
            (this.answers[q.id].type === 'radio' && this.answers[q.id].value !== '')
          ) {
            pass = true;
          }
        }
      }
      return pass;
    },
    setRadioAnswer(v) {
      const [type, questionId, answerId] = Object.keys(v)[0].split('-');
      this.setAnswer({ type, questionId, answerId });
    },
    setCheckboxAnswer(questionId, answerId, value) {
      //const [type, questionId, answerId] = Object.keys(v)[0].split('-');
      this.setAnswer({ type: 'checkbox', questionId, answerId });
    },
    setSelectAnswer(question, event) {
      const index = event.target.value;
      const questionId = question.id;
      const type = 'select';
      let answerId = '-1';
      if (typeof question.answers[index] !== 'undefined') {
        answerId = question.answers[index].id;
      }
      this.setAnswer({ type, questionId, answerId });
    },
    setTextAnswer(type, questionId, value) {
      this.setAnswer({ type, questionId, value });
    },
    closeQuestions() {
      this.$emit('hideQuestions');
    },
    selectOptions(options) {
      const r = [];
      options.forEach((o) => {
        r.push({
          name: o.answer,
        });
      });
      return r;
    },
  },
  mounted() {
    this.clearAnswers();
    this.firstTry = true;
  },
};
</script>

<style lang="scss" scoped>
/*.questions {
position: fixed;
background: white;
top: 5vh;
left: 50%;
bottom: 5vh;
margin-left: -30em;
min-height: 90vh;
width: 60em;
z-index: 1001;
box-shadow: 0 2px 4px 0 #AAADAC;
display: flex;
flex-direction: column;
@media screen and (max-width: $screen-md) {
width: 90%;
margin-left: -45%;
}
}*/
.header {
  position: fixed;
  width: inherit;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: $sp;
  padding-right: $sp;
  background: white;
  overflow-y: auto;
  border-bottom: 1px solid $navbar-default-border;
}
.close {
  margin-top: $sp;
}
.questionsForm {
  margin-top: calc(43px + 1em);
  padding-top: 2 * $sp;
  overflow-y: scroll;
  padding-left: 2 * $sp;
  padding-right: 2 * $sp;
  flex-grow: 1;
}
.questionText {
  margin-bottom: 1em;
}

.question {
  margin-bottom: 2em;
}
.actions {
  margin-top: 3em;
  margin-bottom: 4em;
  text-align: center;
  button {
    margin-left: calc($sp / 2);
    margin-right: calc($sp / 2);
  }
}

.radio :deep(button),
.question {
  display: flex;
  flex-direction: column;
}

.required :deep(.icon .fill) {
  fill: $state-danger-text !important;
}
</style>
